export default __webpack_public_path__ + "static/media/Ballroll_00034.becee2c6.png";